import { DEMO_MODE } from "@/demo/config";
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = DEMO_MODE
  ? "https://example.invalid"
  : import.meta.env.VITE_SUPABASE_URL || "";
const supabaseAnonKey = DEMO_MODE
  ? "meeting-preview-no-credentials"
  : import.meta.env.VITE_SUPABASE_ANON_KEY || "";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  ...(DEMO_MODE
    ? {
        global: {
          fetch: async () => {
            throw new Error("Production data is disabled in the meeting demo");
          },
        },
      }
    : {}),
  auth: {
    persistSession: !DEMO_MODE,
    autoRefreshToken: !DEMO_MODE,
    detectSessionInUrl: !DEMO_MODE,
  },
});

/**
 * A throwaway client for checking a password without touching the portal's
 * own session: nothing is stored, nothing auto-refreshes, and the portal's
 * auth listeners never hear about it. Sign it out with scope 'local', never
 * 'global' (that would end every session of the user, the portal's included).
 */
export function createIsolatedAuthClient() {
  return createClient(supabaseUrl, supabaseAnonKey, {
    auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false, storageKey: "bmc-password-check" },
  });
}
